import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarHeart } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const WORDS = { higher: "higher than", lower: "a bit lower than", same: "about the same as", new: "your first one tracked for" };

export const NudgeResults = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/insights/nudge-results").then((x) => setR(x.data)).catch((e) => logError("Nudge results failed:", e)); }, []);
  if (!r) return null;
  const { latest: l, summary: s } = r;
  return (
    <div className="mm-card p-5" data-testid="nudge-results">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="font-semibold flex items-center gap-2 whitespace-nowrap"><CalendarHeart size={18} /> Tough-day nudges</div>
        <Link to="/plan" className="mm-chip !py-1.5 text-sm whitespace-nowrap" data-testid="insights-open-plan">Open today's plan</Link>
      </div>
      {l ? (
        <>
          <p className="text-sm mt-3" data-testid="nudge-results-latest">
            On your last nudge day ({l.weekday}, {l.date}) your mood was <b>{l.mood}</b>
            {l.verdict === "new" ? " — the first one we can compare." : <> — {WORDS[l.verdict]} your usual {l.weekday} ({l.usual}).</>}
            {" "}{l.opened_plan ? "You opened your plan that day 💜" : "Next time, the plan is one tap away."}
          </p>
          {s.days > 1 && (
            <div className="grid grid-cols-3 gap-2 mt-4 text-center" data-testid="nudge-results-summary">
              {[["Higher", s.higher], ["About the same", s.same], ["Lower", s.lower]].map(([k, v]) => (
                <div key={k} className="mm-soft py-2"><div className="font-display text-lg font-bold text-mm-primary">{v}</div><div className="text-[11px] text-mm-muted">{k}</div></div>
              ))}
            </div>
          )}
          {s.days > 1 && <p className="text-xs text-mm-muted mt-2">Nudge days vs usual over {s.days} days · plan opened {s.plans_opened}×</p>}
        </>
      ) : <p className="text-sm text-mm-muted mt-2" data-testid="nudge-results-empty">After a nudge day, you'll see here how it compared with your usual — check in that day to track it.</p>}
    </div>
  );
};
